import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import ReconTypeForm from '../../../components/forms/ReconTypeForm';
import { useReconTypeApi } from '../../../hooks/useReconTypeApi';
import { useNavigate } from 'react-router-dom';
import { ReconTypeDTO } from '../../../services/apiClient';

const ReconTypeCreate: React.FC = () => {
  const { create, isLoading } = useReconTypeApi();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Recon Types', href: '/admin/recontypes' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: ReconTypeDTO) => {
    try {
      setIsSubmitting(true);
      await create(data);
      navigate('/admin/recontypes');
    } catch (error) {
      console.error('Error creating ReconType:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/recontypes"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Settings.ReconType.Edit"
    >
      <ReconTypeForm
        initialValues={{} as ReconTypeDTO}
        onSubmit={handleSubmit}
        onCancel={() => navigate('/admin/recontypes')}
        isLoading={isSubmitting}
      />
    </AdminLayout>
  );
};

export default ReconTypeCreate;
